import { ScoreData } from '../PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';

export const filterPartnerScore = (selectedCountry: string | null, allPartnerScores: ScoreData[]): ScoreData[] => {
  if (!selectedCountry) {
    return allPartnerScores.map(score => ({
      ...score,
      responseId: score.responseId ? score.responseId.toString() : null,
    }));
  }

  const filteredScores = allPartnerScores.filter(score => score.country === selectedCountry);

  if (filteredScores.length === 0 || filteredScores.every(score => score.responseId === null)) {
    return [
      { country: selectedCountry, year: 2021, quarter: 1, responseId: null, survey_source: '-' },
      { country: selectedCountry, year: 2021, quarter: 2, responseId: null, survey_source: '-' },
    ];
  }

  return filteredScores.map(score => ({ ...score, responseId: score.responseId ? score.responseId.toString() : null }));
};
